import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  LegendBoxContentsName,
  LegendBoxList,
  LegendCssSquareIconListItem,
  LegendListDivider
} from "../../legend/LegendBoxComponents";
import { memo } from "react";
import { useRecoilValue } from "recoil";
import { WX_ID_LFM } from "../../../store/WeatherContentsState";
import { modelLevelWithID } from "../../../store/ModelLevelState";

function LegendLfmSub() {
  const {t} = useTranslation();
  const level = useRecoilValue(modelLevelWithID(WX_ID_LFM));

  const isUpper = level !== '0';

  return (
    <>
      {!isUpper &&
        <Box>
          <Box sx={{minWidth: 115}}>
            <LegendBoxContentsName>{t("Precipitation")} (mm/h)</LegendBoxContentsName>
          </Box>
          <Box sx={{display: "flex"}}>
            <LegendBoxList>
              <LegendCssSquareIconListItem background={'rgba(255, 0, 255, 0.5)'} text={<>80</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(244, 0, 161, 0.5)'} text={<>64</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(255, 0, 0, 0.5)'} text={<>56</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(255, 21, 6, 0.5)'} text={<>48</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(255, 140, 0, 0.5)'} text={<>40</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(255, 165, 0, 0.5)'} text={<>32</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(255, 191, 0, 0.5)'} text={<>24</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(255, 255, 0, 0.5)'} text={<>16</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(135, 255, 6, 0.5)'} text={<>12</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(0, 255, 0, 0.5)'} text={<>8</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(6, 207, 34, 0.5)'} text={<>4</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(0, 0, 255, 0.5)'} text={<>2</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(0, 144, 255, 0.5)'} text={<>1</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(0, 255, 255, 0.5)'} text={<>0.5</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(178, 203, 228, 0.5)'} text={<>0.1</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
            </LegendBoxList>
          </Box>
        </Box>
      }
      {
        isUpper &&
        <Box>
          <Box sx={{whiteSpace: 'nowrap'}}>
            <LegendBoxContentsName>{t("Relative Humidity")} (%)</LegendBoxContentsName>
          </Box>
          <Box sx={{display: "flex"}}>
            <LegendBoxList>
              <LegendCssSquareIconListItem background={'rgba(14, 71, 71, 0.5)'} text={<>100</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(21, 106, 106, 0.5)'} text={<>95</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(29, 141, 141, 0.5)'} text={<>90</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(35, 177, 177, 0.5)'} text={<>85</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(78, 220, 220, 0.5)'} text={<>80</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(149, 234, 234, 0.5)'} text={<>75</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(184, 241, 241, 0.5)'} text={<>70</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
            </LegendBoxList>
          </Box>
        </Box>
      }
    </>
  )
}

export default memo(LegendLfmSub);
